(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["available-offers"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var copyButtons = document.querySelectorAll('.copy-btn');

    copyButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var couponCode = this.getAttribute('data-clipboard-text');

        navigator.clipboard
          .writeText(couponCode)
          .then(function () {
            button.textContent = 'Copied!';
            setTimeout(function () {
              button.textContent = 'Copy';
            }, 3000);
          })
          .catch(function (err) {
            console.error('Failed to copy text: ', err);
          });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coll-footer-collapsible"]) return;
  try {
    
  var coll = document.getElementsByClassName('collapsible');
  var i;

  for (i = 0; i < coll.length; i++) {
    coll[i].addEventListener('click', function () {
      this.classList.toggle('active');
      var content = this.nextElementSibling;
      if (content.style.display === 'block') {
        content.style.display = 'none';
      } else {
        content.style.display = 'block';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-footer-collapsible"]) return;
  try {
    
   var coll = document.getElementsByClassName("collapsible");
  var i;

  for (i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var content = this.nextElementSibling;
      if (content.style.display === "block") {
        content.style.display = "none";
      } else {
        content.style.display = "block";
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
